
import { AppBar, Toolbar, Button, Box } from '@mui/material';
import { useState, useRef, useEffect } from 'react';
import './header.css'
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import { School, CalendarToday, History, Logout, CalendarTodayOutlined, HistoryOutlined } from '@mui/icons-material';
import { TreeView, TreeItem } from '@mui/x-tree-view';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout, reset } from '../../features/auth/authSlice';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { styled, useTheme } from '@mui/material/styles';
import authService from '../../features/auth/authService';
import commonService from '../../features/common/commonService';
import { NavLink } from 'react-router-dom';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Fade from '@mui/material/Fade';


const StyledTreeItemRoot = styled(TreeItem)(({ theme }) => ({
    color: theme.palette.text.secondary,
    '& .MuiTreeItem-content': {
        color: theme.palette.text.secondary,
        borderTopRightRadius: theme.spacing(2),
        borderBottomRightRadius: theme.spacing(2),
        paddingRight: theme.spacing(1),
        fontWeight: theme.typography.fontWeightMedium,
        '&.Mui-expanded': {
            fontWeight: theme.typography.fontWeightRegular,
        },
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
        '&.Mui-focused, &.Mui-selected, &.Mui-selected.Mui-focused': {
            backgroundColor: `var(--tree-view-bg-color, ${theme.palette.action.selected})`,
            color: 'var(--tree-view-color)',
        },
        '& .MuiTreeItem-label': {
            fontWeight: 'inherit',
            color: 'inherit',
        },
    },
    '& .MuiTreeItem-group': {
        marginLeft: 0,
        '& .MuiTreeItem-content': {
            paddingLeft: theme.spacing(2),
        },
    },
}));

function StyledTreeItem(props) {
    const theme = useTheme();
    const {
        bgColor,
        color,
        labelIcon: LabelIcon,
        labelInfo,
        labelText,
        colorForDarkMode,
        bgColorForDarkMode,
        ...other
    } = props;

    const styleProps = {
        '--tree-view-color': theme.palette.mode !== 'dark' ? color : colorForDarkMode,
        '--tree-view-bg-color':
            theme.palette.mode !== 'dark' ? bgColor : bgColorForDarkMode,
    };

    return (
        <StyledTreeItemRoot
            label={
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        p: 0.5,
                        pr: 0,
                    }}
                >
                    <Box component={LabelIcon} color="inherit" sx={{ mr: 1 }} />
                    <Typography variant="body2" sx={{ fontWeight: 'inherit', flexGrow: 1 }}>
                        {labelText}
                    </Typography>
                    <Typography variant="caption" color="inherit">
                        {labelInfo}
                    </Typography>
                </Box>
            }
            style={styleProps}
            {...other}
        />
    );
}

StyledTreeItem.propTypes = {
    bgColor: PropTypes.string,
    bgColorForDarkMode: PropTypes.string,
    color: PropTypes.string,
    colorForDarkMode: PropTypes.string,
    labelIcon: PropTypes.elementType.isRequired,
    labelInfo: PropTypes.string,
    labelText: PropTypes.string.isRequired,
};

function Header() {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    let [isLoading, setIsLoading] = useState(false);
    let [selectedYearfordropdown, setSelectedYearfordropdown] = useState('')
    let [selectedYear, setSelectedYear] = useState('')
    const [data, setAcademicData] = useState(null);

    useEffect(() => {
        // if (!selectedYear) {
            // localStorage.setItem("selectedYear", '');
            // localStorage.setItem("academicyear",'currentyear');
        // }
        const fetchAcademicYear = async () => {
            setIsLoading(true);
            try {
                const response = await commonService.getAcademicYear();
                setSelectedYearfordropdown(response.academicYears)
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchAcademicYear();
    }, []);

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        } else if (event.key === 'Escape') {
            setOpen(false);
        }
    }

    const logoutClick = () => {
        dispatch(logout());
        dispatch(reset());
        navigate('/login');

    }

    // return focus to the button when we transitioned from !open -> open
    const prevOpen = useRef(open);
    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }
        prevOpen.current = open;
    }, [open]);

    const handleYearSelection = (selectedYear_new) => {
        if(window.location.pathname==="/wested/coordinator"){
            
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        }
        console.log("Selected year: ", selectedYear_new.year);
        // localStorage.setItem("academicyear","currentyear");
        if (selectedYear_new.year!==undefined) {
            setSelectedYear(selectedYear_new.year);
            localStorage.setItem("selectedYear", selectedYear_new.year);
            
            localStorage.setItem("academicyear",selectedYear_new._id );
        } else {
            setSelectedYear("");
            localStorage.setItem("selectedYear", '');
            localStorage.setItem("academicyear",'currentyear');
            // localStorage.removeItem("selectedYear");
            localStorage.setItem("academicyear","currentyear");
        }
        setOpen(true);
    };

    const redirectToLink = () => {
        window.open("https://calschls.org/my-surveys/#private_data_dashboards", '_blank');
    };

        return (
            <div>
                <AppBar position="static" className={localStorage.getItem("selectedYear") ? 'historicalnavBg' : 'navBg'}>
                    <Toolbar className='toolBar'>
                        <div className='logoContainer'>
                            <img src={require('../../assets/images/dashboardLogo.png')} alt="logo" className='logoImg' />
                        </div>
                        {(authService.getDist()) ? (
                            <>
                                {/* <Link to={"home"} className="navLink" > <Button color="inherit">Home</Button></Link> */}
                                <NavLink to={"home"} className="navLink" activeClassName="active"><Button color="inherit">Home</Button></NavLink>
                                <NavLink to={"survey"} className="navLink" activeClassName="active"><Button color="inherit">Survey</Button></NavLink>
                                <NavLink to={"enrollment"} className="navLink" activeClassName="active"><Button color="inherit">Enrollments</Button></NavLink>
                                <NavLink to={"report"} className="navLink" activeClassName="active"><Button color="inherit">Order Reports</Button></NavLink>
                                { localStorage.getItem("academicyear") === 'currentyear' ?<NavLink to={"dashboard"} className="navLink" activeClassName="active"><Button color="inherit">Manage Dashboard Users</Button></NavLink>: ''}
                                { localStorage.getItem("academicyear") === 'currentyear' ?<NavLink to={"costestimate"} className="navLink" activeClassName="active"><Button color="inherit">Cost Estimates</Button></NavLink>: ''}
                                <NavLink to={"https://calschls.org/response_counts/"}  target="_blank" className="navLink"><Button color="inherit">Response Counts</Button></NavLink>
                                {(authService.getRole() == 'admin') ?
                                    <>
                                        {/* <NavLink to={"https://calschls.org/my-surveys/#private_data_dashboards"}  target="_blank" className="navLink"><Button color="inherit">Response Counts</Button></NavLink> */}
                                        {/* <NavLink to={"coordinator"} className="navLink" activeClassName="active"><Button color="inherit">Coordinators</Button></NavLink> */}
                                        <NavLink to="coordinator" className="navLink" activeClassName="active"> <Button color="inherit"> Coordinators {localStorage.getItem('selectedYear') ? `(${localStorage.getItem('selectedYear')})` : ''} </Button> </NavLink>

                                    </>
                                    : ''

                                }
                            </>
                        ) :
                            // <Link to={"coordinator"} className="navLink">  <Button color="inherit">Coordinators</Button></Link>  
                            <NavLink to={"coordinator"} className="navLink active" activeClassName="active"><Button color="inherit">Coordinators {localStorage.getItem('selectedYear') ? `(${localStorage.getItem('selectedYear')})` : ''}</Button></NavLink>

                        }

                        <Box sx={{ marginLeft: 'auto', marginRight: '10px' }}>
                            <Button
                                color="inherit"
                                sx={{ 'marginLeft': '0px !important;' }}
                                ref={anchorRef}
                                id="composition-button"
                                aria-controls={open ? 'composition-menu' : undefined}
                                aria-expanded={open ? 'true' : undefined}
                                aria-haspopup="true"
                                onClick={handleToggle}>

                                <span className='dotProxy'>{localStorage.getItem('adminname') ? localStorage.getItem('adminname').charAt(0) : localStorage.getItem('firstName').charAt(0)}</span>
                                <span className='welcomeMessage'>Welcome {localStorage.getItem('adminname') ? localStorage.getItem('adminname') : localStorage.getItem('firstName')}</span>
                            </Button>

                            <Popper
                                open={open}
                                anchorEl={anchorRef.current}
                                role={undefined}
                                placement="bottom-start"
                                transition
                                disablePortal
                                style={{ "zIndex": "1" }}
                            >
                                {({ TransitionProps, placement }) => (
                                    <Grow
                                        {...TransitionProps}
                                        style={{
                                            transformOrigin:
                                                placement === 'bottom-start' ? 'left top' : 'left bottom',
                                        }}
                                    >
                                        <Paper>
                                            <ClickAwayListener onClickAway={handleClose}>

                                                <TreeView
                                                    id="composition-menu"
                                                    aria-label="gmail"
                                                    defaultExpanded={['3']}
                                                    defaultCollapseIcon={<ArrowDropDownIcon />}
                                                    defaultExpandIcon={<ArrowRightIcon />}
                                                    defaultEndIcon={<div style={{ width: 24 }} />}
                                                    sx={{ height: 'auto', flexGrow: 1 }}
                                                >

                                                    {authService.getRole() == 'admin' ?
                                                        <Link to={"schooldashboard"} className="headerDropdown" onClick={() => setOpen(false)}>
                                                            <StyledTreeItem nodeId="1" labelText="Manage Schools" labelIcon={School} />
                                                        </Link> : ''}
                                                    {authService.getRole() == 'admin' ?
                                                        <Link to={"managedistrict"} className="headerDropdown" onClick={() => setOpen(false)}>
                                                            <StyledTreeItem nodeId="2" labelText="Manage Districts" labelIcon={LocationCityIcon} />
                                                        </Link> : ''}
                                                        {/* {authService.getRole() === 'admin' ? ( */}
                                                    <a href="https://calschls.org/my-surveys/#private_data_dashboards" className="headerDropdown" target="_blank" onClick={() => setOpen(false)}>
                                                        <StyledTreeItem nodeId="3" labelText="Data Dashboards" labelIcon={DashboardCustomizeIcon} />
                                                    </a>

                                                    {authService.getRole() == 'admin' ?
                                                        <Link to={"/"} className="headerDropdown" onClick={() => setOpen(false)}>
                                                            <StyledTreeItem
                                                                nodeId="4"
                                                                labelText="Current Year"
                                                                labelIcon={CalendarToday}
                                                                onClick={() => handleYearSelection("")} />
                                                        </Link> : ''}
                                                    {authService.getRole() == 'admin' ?
                                                        
                                                        <StyledTreeItem
                                                            nodeId="5"
                                                            labelText="Historical Data"
                                                            labelIcon={History}
                                                        >
                                                            
                                                            {Array.isArray(selectedYearfordropdown) && selectedYearfordropdown.map((hist_year, index) => (
                                                                <Link to={"coordinator"} className="headerDropdown" onClick={() => setOpen(false)}>
                                                                    <StyledTreeItem 
                                                                     key={hist_year._id}
                                                                      nodeId={(index + 7).toString()}
                                                                       labelText={hist_year.isCurrentYear ? '' : hist_year.year}
                                                                        color="#1a73e8"
                                                                         bgColor="#e8f0fe"
                                                                          labelIcon=""
                                                                           colorForDarkMode="#B8E7FB"
                                                                            bgColorForDarkMode="#071318"
                                                                            onClick={() => handleYearSelection(hist_year.isCurrentYear ? '' : hist_year)}
                                                                    /> 
                                                                    </Link>
                                                            ))}
                                                           
                                                        </StyledTreeItem>
                                                        
                                                        : ''}
                                                    <StyledTreeItem
                                                        onClick={logoutClick}
                                                        className="menuItem"
                                                        name="logout"
                                                        nodeId="6"
                                                        labelText="Sign Out"
                                                        labelIcon={Logout} />
                                                </TreeView>
                                            </ClickAwayListener>
                                        </Paper>
                                    </Grow>
                                )}
                            </Popper>
                        </Box>
                    </Toolbar>
                </AppBar>

            </div>
        )
    }

export default Header